<template>
	<v-container class="resources-adv__list pa-0 pt-5">
		<div
			v-bind:style="{
				display: 'grid',
				gridTemplateColumns: `repeat(${getColsByDisplayWidth}, 1fr)`,
				gap: '8px',
			}"
		>
			<v-col
				v-for="resourceItem in resourcesItems"
				:key="resourceItem.resource_id"
				class="resources-adv__list-item"
			>
				<router-link
					class="text-decoration-none"
					:to="resourceLink(resourceItem)"
					@click.native="handleResourceClick(resourceItem)"
				>
					<div
						v-if="resourceItem.resource_type === 3"
						class="resources-adv__list-item-img pl-4"
					>
            <SponsorBadge
                v-if="resourceItem.sponsored_by || resourceItem.pin_to_top"
                :text="sponsorText(resourceItem)"
                :top="'0px'"
                :right="'0px'"
                :iconSize="10"
                :iconColor="'#ffffff'"
                :icon="resourceItem.sponsored_by ? 'star' : 'pinned'"
                :width="resourceItem.sponsored_by ? '150' : ''"
            />
						<Icon
							:type="resourceItem.ico"
							:color="resourceItem.color"
							:size="40"
							:pr="16"
						/>
					</div>
					<div
						v-else
						class="resources-adv__list-item-img pl-6"
						:style="{ backgroundImage: backgroundImage(resourceItem) }"
					>

						<div v-if="backgroundImage(resourceItem) === 'none'">
							<ResourceFileIcon
								backgroundColor="#ffffff"
								:fileName="resourceItem.upload.file_real_name"
								:url="resourceItem.upload.url"
								:mr="16"
							/>
						</div>
						<div v-else class="resources-adv__list-item-img-file-icon">
							<ResourceFileIcon
								backgroundColor="#ffffff"
								:fileName="resourceItem.upload.file_real_name"
								:url="resourceItem.upload.url"
								:mr="16"
							/>
						</div>
					</div>
					<p class="resources-adv__list-item-title text-decoration-underline ma-0 mt-2">
						{{ resourceItem.resources_name || resourceItem.upload.file_real_name }}
					</p>
          <div
              :style="{justifyContent: justifyInfo(resourceItem)}"
              class="resources-adv__list__info mt-1">
            <span v-if="resourceItem.path" class="resources-adv__list__info__path">{{ shortenPath(resourceItem.path) }}</span>
            <span v-if="!resourceItem.path"  class="resources-adv__list__info__name">{{ resourceAuthor(resourceItem.resource_author)}}</span>
            <span v-if="!resourceItem.path"  class="resources-adv__list__info__time">
              {{resourceReleaseDate(resourceItem)}}
            </span>
          </div>
				</router-link>
			</v-col>
		</div>
	</v-container>
</template>

<script>
import ResourceFileIcon from './ResourceFileIcon.vue'
import Icon from '@/components/Icon'
import Dwh from '@/mixins/Dwh'
import SponsorBadge from "@/components/SponsorBadge.vue";

export default {
	components: {
    SponsorBadge,
		Icon,
		ResourceFileIcon,
	},
	mixins: [Dwh],
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
    sponsorText(item) {
      if (item && item.sponsored_by) return `Sponsored by ${item.sponsored_by}`
      if (item && item.pin_to_top) return 'Pinned'
      return ''
    },
    shortenPath(path) {
      if (!path) return ""
      const parts = path.split(" > ")
      if (parts.length <= 3) {
        return parts.join(" > ")
      }
      const first = parts[0]
      const lastTwo = parts.slice(-2)

      return `${first} > ... > ${lastTwo.join(" > ")}`
    },
		resourceLink(resourceItem) {
			const name = resourceItem.resource_type === 3 ? 'resources' : 'resource-file'
			const params = {
				name,
				query: {
					category_id: resourceItem.resource_id,
					advance: '1',
				},
			}
			if (resourceItem.resource_type === 3) {
				params.query.title = resourceItem.resources_name
			}
			return params
		},
		backgroundImage(resourceItem) {
			return resourceItem.resource_image ? `url(${resourceItem.resource_image})` : 'none'
		},
		fileType(resourceItem) {
			if (resourceItem.upload.metadata) {
				return resourceItem.upload.filename.substring(
					resourceItem.upload.filename.lastIndexOf('.') + 1
				)
			} else {
				return 'file'
			}
		},
    dateCreated(originalDate) {
      const date = new Date(originalDate * 1000)
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return date.toLocaleDateString('en-US', options)
    },
    resourceReleaseDate(resourceItem) {
      if (resourceItem.resource_release_date) {
        const date = new Date(resourceItem.resource_release_date * 1000)
        const options = {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        }
        const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date)
        return formattedDate
      } else if (resourceItem.upload && resourceItem.upload.time) {
        return this.dateCreated(resourceItem.upload.time)
      }
      return ''
    },
		handleResourceClick(resourceItem) {
			this.sendTrigger({
				category: 'Content',
				action:
					resourceItem.resource_type === 3
						? 'click_resources_folder'
						: 'click_resources_file',
				module: 'Resources',
				data: resourceItem.resource_id,
				title: resourceItem.resources_name,
				content_chapter_id: resourceItem.chapter_id ? [resourceItem.chapter_id] : null,
			})
		},
    resourceAuthor(name) {
      const nameAuthor = name || ''
      if (typeof nameAuthor !== 'string') return ''
      return nameAuthor.length > 30
          ? nameAuthor.slice(0, 30) + '...'
          : nameAuthor
    },
  },
	computed: {
    justifyInfo() {
      return (item) => {
        const author = this.resourceAuthor(item.resource_author)
        return author ? '' : 'flex-end'
      }
    },
		getColsByDisplayWidth() {
			const displayWidth = this.$vuetify.breakpoint.width
			return displayWidth >= 600 ? '3' : displayWidth <= 380 ? '1' : '2'
		},
	},
}
</script>

<style lang="scss">
.resources-adv__list {
  &__info{
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    height: 24px;
    &__path{
      font-family: 'Inter', sans-serif;
      font-weight: 400;
      font-size: 13px;
      line-height: 100%;
      letter-spacing: 0;
      color: #9b9b9b;
      cursor: pointer;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      word-break: break-word;
      min-height: 27px;
    }
    &__name{
      font-family: 'Inter', sans-serif;
      font-weight: 500;
      font-size: 10px;
      line-height: 100%;
      letter-spacing: 0;
      color: var(--username-category-title)!important;
      white-space: nowrap;
    }
    &__time{
      font-family: 'Inter', sans-serif;
      font-weight: 400;
      font-size: 10px;
      line-height: 100%;
      letter-spacing: 0;
      color: #9b9b9b;
      white-space: nowrap;
    }
  }
	&-item {
		background-color: #fff;
		border-radius: 8px;
		padding: 8px;
		border: 1px solid #e2e2e2;

		&-img {
			background-color: #f3f3f6;
			border-radius: 8px;
			height: 152px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			background-position: center;
			background-size: cover;
			background-repeat: no-repeat;
			position: relative;

			&-file {
				background-color: var(--accent-color);

				&-icon,
				&-icon-small {
					display: flex;
					justify-content: center;
					align-items: center;
					position: absolute;
					bottom: 4px;
					right: -12px;

					img {
						height: 20px;
						width: 20px;
					}

					&-small {
						width: 20px;
						height: 20px;
						border-radius: 4px;
						right: 12px;
					}
				}
				&-icon-common {
					img {
						mix-blend-mode: multiply;
					}
				}
			}
		}

		&-title {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--username-category-title)!important;
			cursor: pointer;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;
			min-height: 27px;
		}
	}
}
</style>
